module.exports = __webpack_public_path__ + "assets/b4c996d229b3b4e8fd260305160eaf83.mp3";